import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Jersey } from '@sorare/core/src/assets/icons/Jersey';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getSameActiveClubRule_so5Rules } from './__generated__/getSameActiveClubRule.graphql';

export const getSameActiveClubRule = withFragments(
  (
    rules: getSameActiveClubRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.sameActiveClub;
    const { min, max } = rule || {};
    if (!min && !max) return null;
    const displayMinAndMax = min && max ? 'minAndMax' : 'maxOnly';

    return {
      id: 'sameActiveClubs',
      label: (
        <FormattedMessage
          id="Rules.SameActiveClubRule.title"
          defaultMessage="<b>{display, select, between {Between {min} and {max}} min {Min {min}x} other {Max {max}x}}</b> players from the same club"
          values={{
            b: Bold,
            display: min && !max ? 'minOnly' : displayMinAndMax,
            min,
            max,
          }}
        />
      ),
      error,
      icon: <Jersey size={2} />,
    };
  },
  {
    so5Rules: gql`
      fragment getSameActiveClubRule_so5Rules on So5Rules {
        id
        sameActiveClub {
          min
          max
        }
      }
    ` as TypedDocumentNode<getSameActiveClubRule_so5Rules>,
  }
);
